import React, { useState } from "react";

const Platform = () => {
  const [activeTab, setActiveTab] = useState("students");
  const [showModal, setShowModal] = useState(false);

  const tabs = [
    { id: "students", label: "Students" },
    { id: "institutions", label: "Partner Institutions" },
  ];

  const slides = {
    students: {
      title: "Students",
      description:
        "At ApplicationUni, we connect students with programs and institutions that align with their background, skills, and ambitions. Our platform helps you choose the right education path, providing support every step of the way. With our AI-powered eligibility check, get matched with institutions that suit your aspirations and apply with ease.",
      image:
        "https://plus.unsplash.com/premium_photo-1682974407026-581fe0e550ea?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
    institutions: {
      title: "Partner Institutions",
      description:
        "At ApplicationUni, we collaborate with leading educational institutions from around the world to create opportunities for students to achieve academic excellence. As a partner institution, you gain access to a global pool of talented, motivated students seeking to study abroad. Our platform bridges the gap between institutions and students, making the admission process seamless and efficient.",
      image:
        "https://imgs.search.brave.com/IX91tpaxPqRgPZD7xJpDZPI9JdONMvVy1wvCOpsFWvQ/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5pc3RvY2twaG90/by5jb20vaWQvMTQ1/NTE2Nzc2NS9waG90/by9tZWV0aW5nLXRo/ZS1uZXctYnVzaW5l/c3MtcGFydG5lci5q/cGc_Yj0xJnM9MTcw/NjY3YSZ3PTAmaz0y/MCZjPWlUcGpUem5t/MWU5Skd3X05IeENl/QWt5OHF2aXByNWJU/WmtjdElmTGVZMFk9",
    },
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-xl md:text-2xl lg:text-4xl notoh font-bold text-center pb-10 pt-10 text-gray-800 notoh">
      AI Powered Platform That Supports You End to End
      </h1>

      {/* Tabs */}
      <div className="flex justify-center overflow-x-auto sm:justify-center mb-8">
        <div className="flex space-x-4 bg-gray-100 rounded-full p-2">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-6 py-2 text-sm font-medium rounded-full ${
                activeTab === tab.id
                  ? "bg-blue-600 text-white"
                  : "bg-gray-100 text-gray-700 hover:bg-blue-600 hover:text-white"
              } transition-all`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Slide Content */}
      <div className="flex flex-col lg:flex-row items-center w-full justify-center max-w-screen-lg mx-auto">
        {/* Text Content */}
        <div className="text-center lg:text-left max-w-md ">
          <h2 className="text-xl md:text-2xl font-bold mb-4">
            {slides[activeTab].title}
          </h2>
          <p className="text-gray-600 mb-6 text-left lg roboto">
            {slides[activeTab].description}
          </p>
          <button
        className="bg-blue-600 text-white px-6 py-2 rounded-full hover:bg-blue-700 transition-all"
        onClick={() => setShowModal(true)}
      >
        Learn More
      </button>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4">
          <div className="bg-white w-full max-w-md md:max-w-lg lg:max-w-xl rounded-lg shadow-lg p-6 relative">
            {/* Close Button */}
            <button
              className="absolute top-3 right-3 text-gray-600 hover:text-gray-800 text-2xl font-bold"
              onClick={() => setShowModal(false)}
            >
              &times;
            </button>
            {/* Modal Content */}
            <h2 className="text-xl md:text-2xl font-semibold mb-4 text-center">
              AI-Powered Eligibility Check
            </h2>
            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              At ApplicationUni, our <strong className="font-bold">AI-powered eligibility check</strong> ensures that you’re matched with the
              best programs and institutions based on your background, skills, and aspirations. This advanced technology
              helps you navigate your education journey with ease, providing personalized guidance every step of the way.
            </p>
            <div className="mt-6 text-center">
              <button
                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-all"
                onClick={() => setShowModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
        </div>

        {/* Image */}
        <div className="mt-6 lg:ml-12 lg:mt-0 flex justify-center w-full p-0 lg:w-1/2    ">
          <img
            src={slides[activeTab].image}
            alt={slides[activeTab].title}
            className="rounded-lg w-full max-w-xs sm:max-w-md lg:max-w-lg h-auto"
          />
        </div>
      </div>

      {/* Indicators */}
      <div className="flex justify-center mt-8 space-x-2">
        {tabs.map((tab) => (
          <span
            key={tab.id}
            className={`w-3 h-3 rounded-full ${
              activeTab === tab.id ? "bg-blue-600" : "bg-gray-300"
            }`}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default Platform;
